var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useContext, useEffect, useState } from "react";
import { ComponentKind, ComponentRender, ReactTranslationContext } from "../../../../index";
import { parse, serialize } from "@wordpress/blocks";
import { useController } from 'react-hook-form';
import { Grid } from '@material-ui/core';
export const TranslatableEditorForLanguage = (_a) => {
    var { name, control, visible, children } = _a, props = __rest(_a, ["name", "control", "visible", "children"]);
    const [gutenbergValue, setGutenbergValue] = useState([]);
    const [init, setInit] = useState(false);
    const { field: { onChange, value }, } = useController({
        name,
        control,
        defaultValue: "",
    });
    useEffect(() => {
        if (!init && value && value.length > 0) {
            setGutenbergValue(parse(value));
            setInit(true);
        }
    }, [value, init]);
    const update = useCallback((v) => {
        setGutenbergValue(v);
        onChange(serialize(v));
    }, [onChange, setGutenbergValue]);
    if (visible) {
        return React.createElement(ComponentRender, Object.assign({ kind: ComponentKind.EDITOR }, props, { value: gutenbergValue, onChange: update }), children);
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
export const TranslatableEditor = (_a) => {
    var { name, required = false, control } = _a, props = __rest(_a, ["name", "required", "control"]);
    const translation = useContext(ReactTranslationContext);
    if (translation === null) {
        throw new Error("Unable to have a translatable editor in such context");
    }
    const fields = translation === null || translation === void 0 ? void 0 : translation.languages.map((code, index) => {
        let fieldName = name;
        if (index > 0) {
            fieldName = `__translation.${index - 1}.${code}.${name}`;
        }
        const visible = (translation === null || translation === void 0 ? void 0 : translation.language) === code;
        return React.createElement(Grid, { key: fieldName, item: true, style: visible ? { display: 'flex' } : { visibility: 'hidden', position: 'absolute' }, xs: 12 },
            React.createElement(TranslatableEditorForLanguage, Object.assign({ key: fieldName }, props, { name: fieldName, control: control, visible: visible })));
    });
    return React.createElement(Grid, { container: true }, fields);
};
//# sourceMappingURL=index.js.map